module.exports = __webpack_public_path__ + "static/media/Group 12.2c8a99a0.svg";